type ViewportSize = Pick<VisualViewport, 'height' | 'scale'>
type ViewportPosition = ViewportSize & Pick<VisualViewport, 'offsetTop'>

/** Layout pixels covered by the visual viewport, independent of pinch zoom. */
export function visualViewportHeight(viewport: ViewportSize | null, fallback: number): number {
  if (!viewport || !Number.isFinite(viewport.height) || viewport.height <= 0) return fallback
  const scale = Number.isFinite(viewport.scale) && viewport.scale > 0 ? viewport.scale : 1
  return viewport.height * scale
}

export function visualKeyboardInset(viewport: ViewportPosition, innerHeight: number): number {
  // At normal scale, Safari can pan the focused input above the keyboard.
  // During pinch zoom offsetTop instead follows the user's pan gesture; it
  // must not turn the keyboard on/off or move the composer on every pan.
  const top = Math.abs(viewport.scale - 1) < 0.01 ? Math.max(0, viewport.offsetTop) : 0
  const covered = Math.max(0, innerHeight - visualViewportHeight(viewport, innerHeight) - top)
  return covered > 120 ? Math.round(covered) : 0
}
